import { Component, OnInit } from '@angular/core'
import { ListingItem } from 'depoto-core/src/models'
import { BaseListing } from '../_base-listing/base-listing'
import { CoreService } from '../../services'
import { Checkout, Depot, ProductMovePack, User } from 'depoto-core/src/entities'
import { productMovePacksColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'
import * as Sentry from '@sentry/angular-ivy'
import { ScrollService } from '../../services/scroll.service'

const DEFAULT_FILTERS = {
  operationType: 'all',
  depot: 0,
  checkout: 0,
  withoutCheckout: false, // deprecated??
  fulltext: '',
  reservationNumber: '',
  billNumberFulltext: '',
  dateFrom: '',
  dateTo: '',
  createdBy: 0,
  productFulltext: '',
  operationNumber: '',
  sortProp: 'created',
  sortDir: 'desc',
}

@Component({
  selector: 'product-move-packs-page',
  templateUrl: 'product-move-packs.component.html',
  styleUrls: ['product-move-packs.component.scss'],
  providers: [ScrollService],
})
export class ProductMovePacksComponent extends BaseListing implements OnInit {
  productMovePacks: ProductMovePack[] = []
  listingColumns: ListingItem[] = productMovePacksColumns
  operationTypes: string[] = ['all', 'in', 'out', 'transfer'] //TODO: should we also translate or not?
  filters = DEFAULT_FILTERS
  depots: Depot[] = [new Depot({ id: 0, name: 'all' })]
  users: User[] = [new User({ id: 0, name: 'all', email: 'all' })]
  checkouts: Checkout[] = [new Checkout({ id: 0, name: 'all' })]
  totalItems = 0
  currentPage: number
  endPage: number
  loading = true
  filterRowsShown = false

  constructor(
    protected core: CoreService,
    public readonly scrollService: ScrollService,
  ) {
    super(core)
    this.getStorageKey('productMoves')
    this.scrollService.setKey(this.core.services.storage.keys.views.productMovePackList)
  }

  async ngOnInit() {
    this.filters = this.loadViewSettings('productMoves') || DEFAULT_FILTERS
    await this.refreshFiltersData()

    if (this.scrollService.getValue()?.productMovePacks) {
      this.loadProducts()
    } else {
      await this.filter(1)
    }
  }

  clearFilters(type?: string): void {
    switch (type) {
      case 'depots':
        this.filters.depot = null
        break
      default:
        this.filters.fulltext = ''
        this.filters.operationType = 'all'
        this.filters.depot = null
        this.filters.checkout = 0
        this.filters.withoutCheckout = false
        this.filters.reservationNumber = null
        this.filters.billNumberFulltext = null
        this.filters.dateFrom = null
        this.filters.dateTo = null
        this.filters.createdBy = 0
        this.filters.productFulltext = null
        this.filters.operationNumber = null
        break
    }
    if (type !== 'depots') {
      this.filter()
    }
  }

  async refreshFiltersData(): Promise<any> {
    this.loading = true
    try {
      this.checkouts = this.checkouts.concat(
        this.core.lists.checkouts.filter(checkout =>
          this.core.services.user.user.checkouts.some(ch => ch.id === checkout.id),
        ),
      )

      this.depots = this.depots.concat(
        this.core.lists.depots.filter(depot => this.core.services.user?.user?.depots?.some(d => d.id === depot.id)),
      )
      this.users = this.users.concat(
        await this.core.services.user
          .getList({}, SchemaUtil.user)
          .then(result => result.items.map(user => new User(user))),
      )
      this.loading = false
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  }

  private loadProducts(): void {
    this.loading = false
    this.reloading = false
    const settings = this.scrollService.getValue()
    Object.keys(settings)?.forEach(value => (this[value] = settings[value]))
    this.scrollService.scrollTo(settings.selectedItem)
  }
  filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false): void {
    const options: any = {}
    this.currentPage = pageNo
    if (this.filters.operationType !== 'all' && this.filters.operationType) options.type = this.filters.operationType
    if (this.filters.depot > 0) options.depot = this.filters.depot
    if (this.filters.fulltext && this.filters?.fulltext?.length > 0) options.fulltext = this.filters.fulltext
    if (this.filters.operationType !== 'transfer') {
      /*TODO:
       * pripad this.filters.checkout === 'none' nemuze nikdy nastat nebo existuje snad ordinace s id none?
       * */
      if (this.filters.withoutCheckout /*|| this.filters.checkout === 'none'*/) options.withoutCheckout = true
      else if (
        this.filters.checkout !== 0 &&
        !isNaN(Number(this.filters.checkout)) &&
        Number(this.filters.checkout) > 0
      ) {
        options.checkouts = [this.filters.checkout]
      } else {
        // // note 2026/08/17
        // // v pripade opType === 'all' se budou vracet i pohyby na pokladnach, ktere user nemusi mit pod sebou prirazene. tmp solution je neposilat na all zadne pokladny, jen je mozne ze user dostane i nektere ksy, ktere by nemel videt
        // options.checkouts = this.filters.operationType === 'out' ? this.checkouts.map(c => c.id) :  []
        // jina moznost je tohle: ale to tedka nefunguje dohromady:
        // options.checkouts = this.checkouts.map(c => c.id)
        // if (this.filters.operationType !== 'out') {
        //   options.withoutCheckout = true
        // }
        // takze nyni vracime vse
      }
    }
    if (this.filters.operationNumber?.length > 0) options.number = this.filters.operationNumber
    if (this.filters.reservationNumber?.length > 0) options.orderFulltext = this.filters.reservationNumber
    if (this.filters.billNumberFulltext?.length > 0) options.orderFulltext = this.filters.billNumberFulltext
    if (this.filters.productFulltext?.length > 0) options.productFulltext = this.filters.productFulltext
    if (this.filters.createdBy && this.filters.createdBy > 0) options.createdBy = this.filters.createdBy
    if (this.filters.dateFrom || this.filters.dateTo) {
      options.created = {}
      if (this.filters.dateFrom?.length > 0) options.created.left_date = this.filters.dateFrom
      if (this.filters.dateTo?.length > 0) options.created.right_date = this.filters.dateTo + 'T23:59:59'
    }

    this.loading = true
    if (!concat) this.reloading = true

    this.core.services.productMovePack
      .getList({ page: pageNo, sort: sortProp, direction: sortDir, filters: options }, SchemaUtil.productMovePackList)
      .then(result => {
        this.loading = false
        this.reloading = false
        if (!concat) {
          this.productMovePacks =
            result?.items?.filter(item => {
              return this.depots.some(depot => {
                return depot.id === item.depotFrom?.id || depot.id === item.depotTo?.id
              })
            }) || []
        } else {
          const itemsWithFilteredUsersDepots =
            result?.items?.filter(item =>
              this.depots.some(depot => {
                return depot.id === item.depotFrom?.id || depot.id === item.depotTo?.id
              }),
            ) || []
          itemsWithFilteredUsersDepots.forEach(movePack => {
            this.productMovePacks.push(new ProductMovePack(movePack))
          })
        }
        this.totalItems = result?.paginator ? result.paginator.totalCount : 0
        this.endPage = result?.paginator ? result.paginator.endPage : 0
        this.scrollService.save('productMovePacks', this.productMovePacks)
        this.scrollService.save('currentPage', this.currentPage)
        this.scrollService.save('endPage', this.endPage)
        this.scrollService.save('totalItems', this.totalItems)
        this.saveViewSettings('productMoves', this.filters)
      })
  }

  get queryFilters() {
    const f = {
      operationType:
        this.filters.operationType !== 'all' && this.filters.operationType?.length
          ? this.filters.operationType
          : undefined,
      depot: this.filters.depot ? this.filters.depot : null,
      checkout: this.filters.checkout ? this.filters.checkout : null,
      /*TODO:
       * pripad this.filters.checkout === 'none' nemuze nikdy nastat nebo existuje snad ordinace s id none?
       * */
      //withoutCheckout: this.filters.checkout === 'none',
      fulltext: this.filters.fulltext?.length ? this.filters.fulltext : '',
      reservationNumber:
        this.filters.reservationNumber?.length || this.filters.reservationNumber !== undefined
          ? Number(this.filters.reservationNumber)
          : '',
      billNumberFulltext: this.filters.billNumberFulltext?.length ? this.filters.billNumberFulltext : '',
      dateFrom: this.filters.dateFrom?.length ? this.filters.dateFrom : '',
      dateTo: this.filters.dateTo?.length ? this.filters.dateTo : '',
      createdBy: 0,
      productFulltext: this.filters.productFulltext?.length ? this.filters.productFulltext : '',
      operationNumber: this.filters.operationNumber ? this.filters.operationNumber : '',
    }
    Object.keys(f).forEach(k => {
      if (f[k] === undefined) {
        delete f[k]
      }
    })
    return f
  }

  downloadReport(report: any) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }
}
